import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, saveSession } from "@/lib/api";
import Navbar from "@/components/karmivo/Navbar";
import GoogleButton from "@/components/karmivo/GoogleButton";

export default function CustomerRegister() {
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", phone: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k,v) => setF(x => ({...x, [k]: v}));
  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/auth/register`, { ...f, email: f.email?.trim() || undefined, role: "customer" });
      saveSession("customer", data); toast.success("Account created"); nav("/");
    } catch (e) {
      const d = e.response?.data?.detail;
      const msg = Array.isArray(d) ? d.map(x => x.msg || JSON.stringify(x)).join(", ") : (typeof d === "string" ? d : "Could not register");
      toast.error(msg);
    }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50"><Navbar/>
      <div className="max-w-md mx-auto px-6 py-16">
        <Card className="p-6">
          <h1 className="font-display text-2xl font-bold text-slate-900">Create your account</h1>
          <div className="mt-5">
            <GoogleButton label="Sign up with Google"/>
            <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
              <div className="flex-1 h-px bg-slate-200"/><span>or with phone</span><div className="flex-1 h-px bg-slate-200"/>
            </div>
          </div>
          <div className="space-y-3">
            <div><Label>Full Name</Label><Input value={f.name} onChange={e => upd("name", e.target.value)} data-testid="reg-name"/></div>
            <div><Label>Phone</Label><Input value={f.phone} onChange={e => upd("phone", e.target.value)} data-testid="reg-phone"/></div>
            <div><Label>Email (optional)</Label><Input value={f.email} onChange={e => upd("email", e.target.value)} data-testid="reg-email"/></div>
            <div><Label>Password</Label><Input type="password" value={f.password} onChange={e => upd("password", e.target.value)} data-testid="reg-password"/></div>
            <Button className="w-full bg-orange-500 hover:bg-orange-600" onClick={submit} disabled={loading} data-testid="reg-submit">Register</Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
